<!-- eslint-disable vue/html-self-closing -->
<template>
  <header
    :class="
      headerIsWhite
        ? scrollDown
          ? '!bg-[#f8f8f8]'
          : '!bg-inherit'
        : '!bg-white'
    "
    class="header-wrapper px-4 py-1.5 flex items-center w-full min-h-12"
    :style="headStyle"
  >
    <van-icon
      name="bars"
      class="!text-2xl"
      v-track="{
        eventCode: 'MPERA.MENU.OPEN',
        extensions: {
          path: $route.path,
          LANG: $i18n.locale,
        },
      }"
      :class="
        headerIsWhite
          ? scrollDown
            ? 'text-inherit'
            : 'text-white'
          : 'text-inherit'
      "
      @click="changeHeaderPopup"
    />

    <img
      :src="headerIsWhite ? (scrollDown ? logo : logoWhite) : logo"
      :alt="getCnOrEn('杰西圈Logo', 'JCtrans Logo')"
      class="w-[102px] h-[27px] object-cover mx-auto"
      @click="handleClickLogo"
      v-gio-track="{
        event: 'clickNavigation',
        attrs: {
          pageCode_var: route.meta.pageCode,
          modulePosition_var: '顶部',
          moduleType_var: '顶部LOGO',
          moduleName_var: '顶部LOGO',
          pageClickName_var: '-',
          $title: '-',
        },
      }"
    />
    <span
      v-if="false"
      class="iconfont icon-a-search_line1 !text-2xl"
      :class="
        headerIsWhite
          ? scrollDown
            ? 'text-inherit'
            : 'text-white'
          : 'text-inherit'
      "
      @click="navigateTo({ name: 'GlobalSearch' })"
    ></span>
    <slot name="rightText"></slot>
    <GlobalH1Tag />
    <van-popup
      v-model:show="showHeaderPopup"
      safe-area-inset-top
      safe-area-inset-bottom
      close-on-popstate
      position="top"
      :teleport="headerRef"
      class="rounded-b-2xl"
      :style="{
        height: '80%',
        width: '100%',
        'overflow-x': 'hidden',
        'overflow-y': 'scroll',
      }"
    >
      <div class="h-full flex flex-col pb-4 menu_content">
        <div class="flex items-center py-1.5 px-4 menu_top">
          <van-icon
            name="cross"
            class="!text-2xl text-[#5E5F64] mr-24"
            @click="changeHeaderPopup"
          />
          <img
            :src="logo"
            :alt="getCnOrEn('杰西圈Logo', 'JCtrans Logo')"
            class="w-[102px] h-[27px] object-cover"
            @click="handleClickLogo"
            v-gio-track="{
              event: 'clickNavigation',
              attrs: {
                pageCode_var: route.meta.pageCode,
                modulePosition_var: '顶部',
                moduleType_var: '顶部LOGO',
                moduleName_var: '顶部LOGO',
                pageClickName_var: '-',
                $title: '-',
              },
            }"
          />

          <LangSwitcher class="ml-auto" />
        </div>

        <!-- <van-divider class="h-[1px] !my-0" /> -->

        <LayoutHeaderMenu />

        <div class="flex items-center justify-center w-full px-4 mt-4 mx-auto">
          <LayoutHeaderUserInfo v-if="isLogin" />
          <template v-else>
            <div class="flex flex-col w-full space-y-2">
              <div
                :class="[
                  'w-full h-12 rounded-lg',
                  'flex items-center justify-center',
                  'font-jc-R bg-jc text-white',
                ]"
                @click="
                  go2LoginPageWithCrmSource(
                    $route.fullPath,
                    'PLT.REG.H5.H5_ERA_HEADER_SIGNIN',
                    'H5头部登录',
                  )
                "
              >
                {{ $t('home.SignIn') }}
              </div>
              <!-- <div
                :class="[
                  'w-full h-12 rounded',
                  'flex items-center justify-center',
                  'font-jc-R bg-white text-jc',
                  'border-jc border',
                ]"
                @click="
                  go2RegisterPage(
                    $route.fullPath,
                    {
                      source: 'PLT.REG.H5.H5_ERA_HEADER_SIGNUP',
                    },
                    {},
                    'H5头部注册',
                  )
                "
              >
                {{ $t('home.SignUp') }}
              </div> -->
            </div>
          </template>
        </div>
      </div>
    </van-popup>
  </header>
</template>

<script setup lang="ts">
  import logo from '@/assets/images/logo@2x.png'
  import logoWhite from '@/assets/images/logo_dark@2x.png'
  import { useScroll } from '@vueuse/core'

  const headerRef = ref(null)
  const route = useRoute()
  const headStyle = computed(() => {
    return route.meta.headStyle || ''
  })
  const router = useRouter()
  const { userId } = storeToRefs(useMyUserStore())
  const { closeHeaderPopup, changeHeaderPopup } = useMySystemStore()
  const { headerIsWhite, showHeaderPopup } = storeToRefs(useMySystemStore())

  const { x, y } = useScroll(document)

  const scrollDown = computed(() => y.value > 40)

  // const currentBgClass = computed(() => {
  //   return headerIsWhite
  //     ? scrollDown.value
  //       ? 'bg-[#f8f8f8]'
  //       : 'bg-inherit'
  //     : 'bg-jc-600'
  // })

  // const iconTextColor = computed(() => {
  //   return headerIsWhite
  //     ? scrollDown.value
  //       ? 'text-inherit'
  //       : 'text-white'
  //     : 'text-inherit'
  // })

  // const logoColor = computed(() => {
  //   return headerIsWhite ? (scrollDown.value ? logo : logoWhite) : logo
  // })
  const handleClickLogo = () => {
    router.push({ name: 'Home' })
    closeHeaderPopup()
  }
  const isLogin = computed(() => {
    return !!userId.value
  })
</script>

<style lang="scss" scoped>
  .header-wrapper {
    position: fixed;
    top: 0;
    z-index: 50;

    .sign-button {
      background: rgb(159 176 193 / 0.2);
      border: none;
      border-radius: 30px;
      opacity: 1;

      :deep(.van-button__text) {
        @apply truncate;

        font-size: 14px;
        font-weight: 500;
        color: #000c31;
      }
    }
  }

  .menu_content {
    min-width: 375px;
    background: #fff;
    border-radius: 0 0 16px 16px;

    .menu_top {
      position: relative;
      top: 0;
      z-index: 99;
      justify-content: space-between;
      width: 100%;
      height: 48px;
      border-bottom: 1px solid #edeff2;
    }
  }
</style>
